import React from 'react'
import styles from './UserGoalsPage.scss'
import {connect} from 'react-redux'
import {browserHistory} from 'react-router'
import {loadGoalsForUser} from 'lib/api/goalsForUser'
import {GoalCard} from '../GoalCards'
import {StandardWidthPage} from 'common/StandardWidthPage'
import {Hero} from 'common/styleguide/Hero'
import heroImg from 'assets/images/goals/hero.jpg'
import heroImg2x from 'assets/images/goals/hero@2x.jpg'
import Helmet from 'react-helmet'
import {GoalTypeCards} from './GoalTypeCards'
import {EditGoalModal} from '../EditGoalModal'
import {createGoal, getDefaultGoal} from 'lib/api/goals'
import {LoginModalOverlay} from 'common/styleguide/LoginModalOverlay'
import {Loadable} from 'common/Loadable'
import {FormattedMessage as T, injectIntl} from 'react-intl'
import {featureNames} from 'lib/localization'

const VALID_GOAL_TYPES = ['distance', 'moving_time', 'elevation_gain', 'leaderboard']

export class UserGoalsPage extends React.PureComponent {
  onSaveComplete = (saveResponse) => {
    const goalId = saveResponse.value.goal.id
    browserHistory.replace(`/goals/${goalId}`)
  }

  render () {
    const {goalsForUser, location, metricUnits, currentUser, intl} = this.props

    const showNewGoalModal = (
      currentUser.id &&
      location.pathname === '/goals/new' &&
      VALID_GOAL_TYPES.includes(location.query.type)
    )

    const showLoginModal = (
      !currentUser.id &&
      location.pathname === '/goals/new'
    )

    return (
      <div className={styles.UserGoalsPage}>
        <Helmet title={`${intl.formatMessage(featureNames.goals)} · Ride with GPS `} />
        {(goalsForUser && goalsForUser.size === 0) &&
          <Hero
            paddingVertical='140px'
            marginBottom='35px'
            scrimOpacity={[0.2, 0.7]}
            img={heroImg}
            img2x={heroImg2x}
            focalPoint='center 68%'
            label={intl.formatMessage(featureNames.goals)}>
            <T
              id='UserGoalsPage.introText'
              defaultMessage='Make {year} your best year yet'
              values={{year: new Date().getFullYear()}} />
          </Hero>
        }
        <StandardWidthPage>
          {/* TODO - handle the case where a user is viewing someone else's goals */}
          {(goalsForUser && goalsForUser.size > 0) &&
            <h1 className={styles.yourGoals}><T id='UserGoalsPage.yourGoals' defaultMessage='Your Goals' /></h1>}
          {goalsForUser && goalsForUser.size > 0 &&
            <div className={styles.goalsList}>
              {goalsForUser.map(gp => <GoalCard goalParticipant={gp} goal={gp.get('goal')} key={gp.get('id')} />).toIndexedSeq().toJS()}
            </div>}
          <h2 className={styles.setGoalHeading}>
            <T id='UserGoalsPage.setGoal' defaultMessage='Set a goal:' />
          </h2>
          <GoalTypeCards />
        </StandardWidthPage>
        {showNewGoalModal && <EditGoalModal
          newGoal
          onRequestClose={() => browserHistory.push('/goals')}
          goal={getDefaultGoal(location.query.type)}
          newGoalType={location.query.type}
          saveGoal={this.props.createGoal}
          onSaveComplete={this.onSaveComplete}
          metricUnits={metricUnits} />}
        {showLoginModal && <LoginModalOverlay onRequestClose={() => browserHistory.push('/goals')} />}
      </div>
    )
  }
}

const I18nUserGoals = injectIntl(UserGoalsPage)

const LoadableGoals = (props) => {
  const noUser = !props.currentUser.id
  // we don't need to load goals if there's no user present
  const resourceLoaded = (noUser || props.goalsLoaded)
    ? true
    : () => props.loadGoalsForUser()

  return <Loadable
    {...props}
    component={I18nUserGoals}
    loadingText='Loading Goals'
    resourceLoaded={resourceLoaded} />
}

const mapStateToProps = (state) => ({
  goalsForUser: state.goalsForUser.get('records'),
  goalsLoaded: state.goalsForUser.get('loaded'),
  currentUser: state.currentUser,
  metricUnits: state.currentUser && state.currentUser.preferences.get('metric_units')
})

const mapDispatchToProps = {
  loadGoalsForUser,
  createGoal
}

export const UserGoalsPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadableGoals)
